import Vue from "vue";

Vue.directive("twodecimals", {
  bind: function(el: any, binding: any, vnode: any) {
    el.addEventListener("focus", (event: any) => {
      if (event.target.value === "0.0" || event.target.value === "0") {
        event.target.value = "0.0";
        event.target.selectionStart = 0;
        event.target.selectionEnd = 3;
      }
    });

    el.addEventListener("keydown", (event: any) => {
      if (
        ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ",", "."].includes(
          event.key
        )
      ) {
        const key = event.key === "," ? "." : event.key;
        let strvalue = event.target.value;

        const selectionStart = event.target.selectionStart;
        const selectionEnd = event.target.selectionEnd;
        const before = strvalue.substring(0, selectionStart);
        const selection = strvalue.substring(selectionStart, selectionEnd);
        const after = strvalue.substring(selectionEnd);
        strvalue = before + key + after;

        const regexresult = /(0|[1-9]\d*)([\.|,]\d?\d?)?/g.exec(strvalue);
        if (regexresult !== null && regexresult.length > 0) {
          const formattedValue = regexresult[0];

          if (formattedValue === strvalue) {
            if (event.key === ",") {
              event.target.value = strvalue;
              event.target.selectionStart = selectionStart + 1;
              event.target.selectionEnd = selectionStart + 1;

              event.preventDefault();

              return;
            } else {
              return;
            }
          } else {
            // One exception, values as 01 have to be transformed to 1
            // so we accept the key but change the value
            const integer = strvalue.split(".")[0];
            const formattedInteger = formattedValue.split(".")[0];
            if (
              formattedInteger.length > 0 &&
              integer.length > 0 &&
              formattedInteger === "0" + integer
            ) {
              event.target.value = strvalue.substring(1);
              event.target.selectionStart = selectionStart;
              event.target.selectionEnd = selectionStart;

              return;
            }
          }
        }

        event.preventDefault();
      } else if (event.key.length === 1) {
        event.preventDefault();
      }
    });
  }
});
